<nk-card class="h-100" andClass="h-100 mb-0" [attr.data-cy]="'company-analysis-network-risk-card'">
  <nk-card-header [title]="'network_risk.title' | translate">
    <nk-help-popover class="ms-2" [popoverTemplate]="networkRiskHelpInfo"></nk-help-popover>
  </nk-card-header>
  <nk-card-content andClass="m-0 p-0">
    <nk-company-analysis-network-risk-score
      [companyIdentifier]="companyIdentifier()"
      [defaultListSize]="defaultListSize()"
      [displayShowMoreButton]="displayShowMoreButton()"
      [printVersion]="printVersion()"></nk-company-analysis-network-risk-score>
  </nk-card-content>
</nk-card>

<ng-template #networkRiskHelpInfo>
  {{ 'network_risk.help_message' | translate }}
</ng-template>
